import React, { useEffect, createElement } from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { PromiseSection } from './components/PromiseSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ProductBreakdown } from './components/ProductBreakdown';
import { BonusStack } from './components/BonusStack';
import { OfferSection } from './components/OfferSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyFloatingCTA } from './components/StickyFloatingCTA';
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    const f = window as any;
    if (!f.fbq) {
      const n: any = f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript?.parentNode?.insertBefore(script, firstScript);
    }
    f.fbq('init', '1962020738043581');
    f.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen font-sans text-brand-charcoal bg-white selection:bg-brand-sage/30 relative pb-24 md:pb-0" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <PromiseSection data-id="element-5" />
        <ProductBreakdown data-id="element-6" />
        <BenefitsSection data-id="element-7" />
        <BonusStack data-id="element-8" />
        <OfferSection data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
        <GuaranteeSection data-id="element-11" />
        <FAQSection data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <StickyFloatingCTA data-id="element-15" />
    </div>;
}